import { makeStyles } from '@material-ui/core/styles'
import { themeCommon } from '../../../styles/theme';

const useStyles = makeStyles((theme) => ({
    rootContainerTab: {
        margin: '0 10px',
    },
    rootContainer: {
        marginTop: '20px',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    indicator: {
        display: 'none',
    },
    rootTabs: {
        alignItems: 'flex-end',
    },
    tabScroller: {
        width: '100%',
    },
    flexContainerVertical: {
        marginBottom: '10px',
        [theme.breakpoints.down('sm')]:{
            flexDirection: 'row',
        },
    },
    rootTab: {
        // color: '#098EAC',
        fontSize: '18px',
        height: '70px',
        width: '100%',
        maxWidth: '100%',
        opacity: 0.6,
        textTransform: 'capitalize',
        // margin: '10px 0',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
            width: '50%',
            maxWidth: '50%',
        },
    },
    rootTabLC: {
        color: '#098EAC',
    },
    rootTabSurvey: {
        color: '#000000',
    },
    tabSelected: {
        color: '#098EAC',
        opacity: 1,
        background: themeCommon.lightBlue,
        [theme.breakpoints.down('sm')]: {
            background: '#FFFFFF',
        },
        '& $tabWrapper': {
            [theme.breakpoints.down('sm')]: {
                background: themeCommon.lightBlue,
                color: '#FFFFFF',
            },
        }
    },
    tabWrapper: {
        width: '200px',
        background: '#FFFFFF',
        borderRadius: '20px',
        boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.25)',
        height: '50px',
        marginRight: '10px',
        [theme.breakpoints.down('sm')]: {
            background: '#FFFFFF',
            color: '#000000',
            fontSize: themeCommon.fontSize12px,
            height: '30px',
        },
    },
    rootContainerBreadcrumb: {
        margin: '0 0 18px 0',
    },
    rootTypography:{
        padding: '0 0 18px 0',
        fontFamily: themeCommon.RobotoBold,
        fontSize: themeCommon.fontSize18px,
        [theme.breakpoints.down('md')]: {
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
    rootTypographyReward: {
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            fontFamily: themeCommon.RobotoBold,
        },
    }
}), {
    name: 'TabsHeadContainer',
    index: 1,
})

export default useStyles